import React from "react";
import { claveFechaDia } from "../../../../Components/fmtFechaDia";
import { fmtMXN, fechaTxt, fmtDias, fmtProporcion, diasProporcionales, calcularImporte } from "./aguinaldoUtils";

/**
 * Desglose del aguinaldo de un empleado, paso por paso: días trabajados en el ejercicio, días de
 * aguinaldo de su tabla, el proporcional y el importe. Es la misma fórmula que el backend
 * (Utils/aguinaldo/propuestaAguinaldo.utils.js), escrita para que el usuario la pueda revisar.
 */
const DetalleCalculoAguinaldo = ({ e, diasAnio, ejercicio, fechaCorte }) => {
  const inicioEsAnio = claveFechaDia(e.inicioComputo) === `${ejercicio}-01-01`;
  const finEsCorte = !e.finComputo || claveFechaDia(e.finComputo) === claveFechaDia(fechaCorte);
  const propuestos = Math.max(0, (e.diasCalendario || 0) - (e.diasIncidencias || 0));
  const diasEditados = Number(e.diasTrabajados) !== propuestos;
  const proporcionales = diasProporcionales(e.diasAguinaldo, diasAnio, e.diasTrabajados);
  const importeFormula = calcularImporte(e.diasAguinaldo, diasAnio, e.diasTrabajados, e.salarioDiario);

  return (
    <ol className="aguinaldo-detalle">
      <li>
        <b>Días trabajados en el ejercicio</b>
        <div>
          {e.inicioComputo ? (
            <>
              Del {fechaTxt(e.inicioComputo)} ({inicioEsAnio ? "inicio del ejercicio" : "fecha de alta"}) al{" "}
              {fechaTxt(e.finComputo || fechaCorte)} ({finEsCorte ? "fecha de corte" : "fecha de baja"}):{" "}
            </>
          ) : "Del inicio del ejercicio a la fecha de corte: "}
          <b>{e.diasCalendario} días</b>
          {e.diasTopados && <span className="aguinaldo-tenue"> (topado a los {diasAnio} días del año)</span>}
        </div>
        {e.diasIncidencias > 0 && (
          <div>
            − {e.diasIncidencias} día(s) de incidencias
            {e.incidenciasManual && <span className="aguinaldo-aviso-texto"> (corregidas a mano)</span>} ={" "}
            <b>{propuestos} días</b>
          </div>
        )}
        {diasEditados && (
          <div className="aguinaldo-aviso-texto">
            Ajustado a mano: {e.diasTrabajados} días (la propuesta era {propuestos}).
          </div>
        )}
      </li>
      <li>
        <b>Días de aguinaldo</b>
        <div>
          {e.sinTablaPrestacion
            ? <span className="aguinaldo-aviso-texto">Sin tabla de prestaciones para su antigüedad: 15 días de ley (Art. 87 LFT).</span>
            : (
              <>
                Tabla {e.tablaPrestacion ? `"${e.tablaPrestacion}"` : "de prestaciones"}
                {e.anioTabla ? `, año de servicio ${e.anioTabla}` : ""} ({e.antiguedadAnios} año(s) cumplidos):{" "}
                <b>{e.diasAguinaldo} días</b>
              </>
            )}
        </div>
      </li>
      <li>
        <b>Proporcional</b>
        <div>
          {e.diasAguinaldo} días × {e.diasTrabajados} días trabajados ÷ {diasAnio} días del año ={" "}
          <b>{fmtDias(proporcionales)} días a pagar</b>
          <span className="aguinaldo-tenue"> ({fmtProporcion(e.diasTrabajados, diasAnio)} del año)</span>
        </div>
      </li>
      <li>
        <b>Importe</b>
        <div>
          {fmtDias(proporcionales)} días × {fmtMXN(e.salarioDiario)} de salario diario ={" "}
          <b>{fmtMXN(importeFormula)}</b>
        </div>
        {e.importeManual && (
          <div className="aguinaldo-aviso-texto">
            Importe capturado a mano: {fmtMXN(e.importe)} (la fórmula da {fmtMXN(importeFormula)}).
          </div>
        )}
      </li>
    </ol>
  );
};

export default DetalleCalculoAguinaldo;
